export interface WebPublishView {
    pendingSince: string | null;
    forceNow: boolean;
    lastState: string;
    lastFinishedAt: string | null;
    lastError: string;
}

export function webPublishCopy(row: WebPublishView, liveSinceLabel: string): { pending: boolean; text: string } {
    if (row.lastState === 'queued' || row.lastState === 'running') {
        return {
            pending: true,
            text: 'Publicando en la web. El pipeline tarda unos 15 minutos. La ficha suelta ya puede responder; el índice y las categorías entran al terminar.',
        };
    }
    if (row.pendingSince || row.forceNow) {
        return {
            pending: true,
            text: 'Pendiente de publicar en la web. Los cambios se agrupan 10 minutos y luego sale el pipeline, unos 15 minutos más. Una ficha nueva responde en segundos; las categorías y el sitemap, al terminar.',
        };
    }
    if (row.lastState === 'failed' && row.lastError) {
        return { pending: false, text: row.lastError };
    }
    if (row.lastFinishedAt && liveSinceLabel) {
        return { pending: false, text: `En la web desde ${liveSinceLabel}.` };
    }
    return { pending: false, text: 'La web pública se actualiza al publicar o activar fichas.' };
}
